
































































































































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { API_URL } from "../global";
import {
  pageDataType,
  sociallinkItem,
  settinglinkItem,
  MainMenuItem,
  RmainMenuItem
} from "../types";
import HomePage from "./HomePage.vue";
import BasicPage from "./BasicPage.vue";
import ContactPage from "./ContactPage.vue";
import JobDetailsPage from "./JobDetailsPage.vue";
import JobIndexPage from "./Career.vue";
import JobCategory from "./CareerList.vue";
import NewsIndexPage from "./NewsIndexPage.vue";
import NewsDetailPage from "./NewsDetailPage.vue";
import JobApplicaionPage from "./JobApplicaionPage.vue";
import TabbedCollectionPage from "./TabbedCollectionPage.vue";
import DynamicLink from "../components/DynamicLink.vue";
import GallaryPage from "./GallaryPage.vue";
import FooterCard from "../components/FooterCard.vue";

import {
  FETCH_MAIN_MENU,
  FETCH_RMAIN_MENU,
  FETCH_SOCIAL,
  FETCH_SETTING
} from "../store/actions.names";
import { pageData } from "@/store/pageData";
import { ADD_ANIMATION } from "../store/mutations.names";

import {
  SET_PRELOADER_LOADED,
  SET_MENU_LOADED
} from "../store/mutations.names";
import axios from "axios";

import {
  TimelineMax,
  TweenLite,
  Power1,
  Power2,
  Cubic,
  Power4,
  TweenMax,
  Elastic,
  Linear,
  Back,
  SlowMo,
  Sine,
  Expo,
  Power3
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from "scrollmagic";

@Component({
  name: "Page",
  components: {
    HomePage,
    TabbedCollectionPage,
    BasicPage,
    NewsIndexPage,
    NewsDetailPage,
    JobIndexPage,
    JobCategory,
    JobDetailsPage,
    ContactPage,
    JobApplicaionPage,
    GallaryPage,
    DynamicLink,
    FooterCard
  },
  beforeRouteUpdate(to: any, from: any, next: any) {
   // console.log("updated");
    if ((this as any).mobileMenuIsActive == true) {
      (this as any).mobileMenuToggle();
      (this as any).MenuDestroy();
    }

    (this as any).MenuDestroy();
    next();
  },
  metaInfo: {
    title: 'Default App Title',
    titleTemplate: '%s | vue-meta Example App'
  }
})
export default class Page extends Vue {
  @Getter("pageData") public PageData!: pageDataType;
  @Getter("pageType") public PageType!: string | null;
  @Getter("mainMenu") public mainMenu!: MainMenuItem[];
  @Getter("rmainMenu") public rmainMenu!: RmainMenuItem[];
  @Getter("sociallink") public sociallink!: sociallinkItem[];
  @Getter("settinglink") public settinglink!: settinglinkItem[];
  @Action(FETCH_MAIN_MENU) public [FETCH_MAIN_MENU]: any;
  @Action(FETCH_RMAIN_MENU) public [FETCH_RMAIN_MENU]: any;
  @Action(FETCH_SOCIAL) public [FETCH_SOCIAL]: any;
  @Action(FETCH_SETTING) public [FETCH_SETTING]: any;
  @Mutation(SET_PRELOADER_LOADED) public [SET_PRELOADER_LOADED]: any;
  @Mutation(SET_MENU_LOADED) public [SET_MENU_LOADED]: any;

  @Getter("isPreloaderLoaded") public preloaderLoaded!: boolean;
  @Getter("isMenuLoaded") public MenuLoaded!: boolean;
  @Prop() public type!: any;
  showNavAnim = false;
  count = 0;
  accordionIndex = 0;
  isDrop: boolean = false;
  isDrops: boolean = false;
  menuReady: boolean = false;
  ItemIndex: any | null = null;
  SubItemIndex: any | null = null;
  show: boolean = false;
  shown: boolean = false;
  isshow: boolean = true;
  showing: boolean = false;
  hover: boolean = false;
  isDropped: boolean = false;
  isActive: boolean = false;
  isDropdownActive: boolean = false;
  mobileMenuIsActive: boolean = false;
  mobileMenuTL: any | null = null;
  mobileNavTrail: any[] = [];
  sbIndex: any | null = null;
  childIndex: any | null = null;
  MenuIsActive: boolean = false;
  preloadDone: boolean = true;
  isMenu: boolean = false;

  mbIndex(idx: any) {
    (this as any).sbIndex = idx;
    this.isMenu = !this.isMenu;
  }
  mChildIndex(indx: any) {
    (this as any).childIndex = indx;
  }
  selectIndex(idx: any) {
    (this as any).ItemIndex = idx;
  }
  selectSubIndex(index: any) {
    (this as any).SubItemIndex = index;
  }
  destroyIndex(idx: any) {
    (this as any).ItemIndex.idx == false;
  }
  MenuDestroy(evt: any | null = null) {
    if (evt != null) {
      evt.preventDefault();
    }
  }

  public navToggle() {
    // console.log("menu");
    this.isshow = false;
    setTimeout(() => {
      this.isshow = true;
    }, 500);
  }

  pushToTrail(mitem: any, idx: number) {
    if (mitem.children) {
      this.mobileNavTrail.push(idx);
    }
  }
  get currentMenuLevel() {
    let val = (this as any).mainMenu;

    if (this.mobileNavTrail.length === 0) {
      return val;
    } else {
      for (const menuLevel of this.mobileNavTrail) {
        val = val[menuLevel].children;
      }
      return val;
    }
  }
  public mbmenu() {
    let d: any = document;
    let box = d.querySelector(".mbmenu");
    const { navlist } = this.$refs;
    let open = false;
    let tl = new TimelineMax({
      paused: true
    });
    tl.pause();
    tl.fromTo(
      ".mbmenu",
      0.5,
      {
        y: -2000,
        ease: Power4.easeOut
      },
      {
        yPercent: 0,
        clearProps: "all"
      },
      0.2
    );
    tl.staggerFrom(
      navlist,
      0.2,
      {
        yPercent: 40,
        autoAlpha: 0,
        ease: Power4.easeOut,
        clearProps: "all"
      },
      0.1
    );

    this.mobileMenuTL = tl;
    // console.log(elements);
  }

  mobileMenuToggle(evt: any | null = null) {
    if (evt != null) {
      evt.preventDefault();
    }
    let d: any = document;
    let box = d.querySelector(".mbmenu");

    if (this.mobileMenuIsActive === false) {
      this.mobileMenuTL.play();
      box.classList.add("active-submenu");
    }
    if (this.mobileMenuIsActive === true) {
      this.mobileMenuTL.reverse();
      box.classList.remove("active-submenu");
    }
    this.mobileMenuIsActive = !this.mobileMenuIsActive;
  }

  mobileMenuNavigate(mitem: any, idx: number) {
    if (mitem.link === null) {
      if (mitem.children.length) {
        //  this.pushToTrail(mitem, idx);
        // this.addmenu();
      }
    } else {
      if (mitem.link.substring(0, 4).toLowerCase() == "http") {
        window.location.href = mitem.link;
      } else {
        this.$router.push(mitem.link);
      }
    }
  }

  @Watch("menuReady")
  handleMenuReadyChange(val: boolean, oldVal: boolean) {
    if (val && val != oldVal) {
      this.$nextTick(() => {
        this.mbmenu();
      });
    }
  }

  get pageTitle(): string {
    return this.PageData
      ? `${(this as any).PageData.title} | SQUAREGROUP`
      : "SQUAREGROUP";
  }
  public goToPage(url: string) {
    this.$router.push(url);
  }
  // job apply router link
  get pageType() {
    if (this.PageType == "JobDetailsPage") {
      var path: string = this.$route.path;
      if (path.slice(-1) == "/") {
        path = path.slice(0, -1);
      }

      let splits = path.split("/");
      const lastPart = splits[splits.length - 1];

      switch (lastPart) {
        case "apply":
          return "JobApplicaionPage"; // Create this Page
        case "success":
          return "JobApllicationSuccessPage"; // And this Page. That's all.
        default:
          return this.PageType;
      }
    } else {
      return this.PageType;
    }
  }

  @Watch("pageTitle")
  public handlePageTitleChange(val: any, oldVal: any) {
    document.title = val;
  }

  @Watch("PageData")
  public handlePageDataChange(val: any, oldVal: any) {}
  // start scroll
  public handleScroll() {
    let scrollpos;
    const d: any = document;
    const nav = d.querySelector(".navigation-area");
    window.addEventListener("scroll", function() {
      scrollpos = window.scrollY || window.pageYOffset;
      if (scrollpos > 70) {
        nav.classList.add("navbar-fixed");
        nav.classList.add("navAnim");
      } else {
        nav.classList.remove("navbar-fixed");
        nav.classList.remove("navAnim");
      }
    });
  }


  public created() {
    window.addEventListener("scroll", this.handleScroll);
  //  window.addEventListener("load", this.preload);
    document.addEventListener("DOMContentLoaded", this.preload);
   
  }

  public destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  //   window.removeEventListener("load", this.preload);
       document.removeEventListener("DOMContentLoaded", this.preload);
  }

  public preload() {
   
    const d: any = document;
    // d.body.style.overflow  = 'hidden';
    // d.body.style.overflow  = 'initial';
    setTimeout(() => {
     //  var preloadDone = false;
      d.body.classList.add("loaded");
    //  d.body.style.overflow  = 'initial';
    //  (this as any).preloadDone = false;
    }, 4000);
  }

    // @Watch("preloaderLoaded")
    // handlePreloaderLoaded(val: any, oldVal: any) {
    //     if (val && !this.MenuLoaded) {
    //         this.navanim();
    //     }
    // }
 navanim() {
var navanim = new TimelineMax({
  delay: 5
});
    navanim
      .staggerFrom(
        ".sq-logo",
        0.8,
        {
          autoAlpha: 0,
          x: -20,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        0.1,
      )
      .staggerFrom(
        ".main-navigation ul .navlist",
        0.5,
        {
          autoAlpha: 0,
          y: 20,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        0.2,"-=.2"
      )
 
  }

  mounted() {
    this.navanim();
    this[FETCH_MAIN_MENU]().then(() => {
      this[FETCH_RMAIN_MENU]().then(() => {
        this.menuReady = true;
         (this as any).preloadDone = true;
      });
    });
    this[FETCH_SOCIAL]();
    this[FETCH_SETTING]();
 const d: any = document;
 d.body.style.overflow  = 'hidden';
     setTimeout(() => {
      d.body.style.overflow  = 'initial';
    }, 4500);
  }
}
